// extracted by mini-css-extract-plugin
export default {"figure":"intro_figure__tqnor"};